import { KnowledgeContentEditorFormValue } from '../types';
import { useSelector } from 'src/store/use-selector';
import _ from 'lodash';
import { KNOWLEDGE_TYPES } from 'shared/constants';
import { Button } from 'src/components/design-system';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-solid-svg-icons/faXmark';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { useContentPreview } from 'src/pages/application/knowledge-content/hooks';
import { RenderPublishButton } from './hub/render-publish-button';
import { Tooltip } from 'src/components/core/tooltip/tooltip.component';

export function RenderHeaderActions({
  knowledgeId,
  isLoading,
  editorFocused,
  values,
  errors,
  initialValues,
  openConfirmationPopup,
  onRevertConversion,
  onSelectBinder,
  onSubmit,
  isValid,
  dirty,
}: {
  knowledgeId: string | undefined;
  isLoading: boolean;
  editorFocused: boolean;
  initialValues: Partial<KnowledgeContentEditorFormValue>;
  values: Partial<KnowledgeContentEditorFormValue>;
  errors: Partial<{
    [K in keyof KnowledgeContentEditorFormValue]: string;
  }>;
  openConfirmationPopup: () => void;
  onRevertConversion: () => void;
  onSelectBinder: () => void;
  onSubmit: () => void;
  isValid: boolean;
  dirty: boolean;
}) {
  const lang = useSelector(s => s.lang.KNOWLEDGE_EDITOR);

  const isSaveDisabled = !isValid || (!dirty && !editorFocused);

  const isNew = !knowledgeId;
  const isContent = values.type === KNOWLEDGE_TYPES.CONTENT;

  const { isHub } = useContentPreview();

  return (
    <>
      {isHub ? (
        <RenderPublishButton
          onSelectBinder={onSelectBinder}
          onSubmit={onSubmit}
          disabled={isLoading || !_.isEmpty(errors)}
        />
      ) : (
        <Button
          htmlType="submit"
          loading={isLoading}
          type="primary"
          disabled={isSaveDisabled}
          icon={<FontAwesomeIcon icon={faCheck} />}>
          {isNew ? lang.CREATE : lang.UPDATE}
        </Button>
      )}
      <Button
        type="default"
        danger
        onClick={openConfirmationPopup}
        disabled={isLoading}
        icon={<FontAwesomeIcon icon={faXmark} />}>
        {lang.DISMISS}
      </Button>
      {!isHub && isContent && !_.isEmpty(initialValues?.link) && (
        <Tooltip title={lang.REVERT_CONVERSION_TOOLTIP}>
          <Button type="default" disabled={isLoading} onClick={onRevertConversion}>
            {lang.REVERT_CONVERSION}
          </Button>
        </Tooltip>
      )}
    </>
  );
}
